import React from "react";
import useWindowDimensions from "../../../../hooks/windowsSize";
import { CustomButton } from "../../button/CustomButton/CustomButton";

type ButtonTheme = "green" | "dark" | "blue" | "red" | "grey" | "lightgrey" | undefined;

interface ButtonProps {
  title: string;
  onClick: () => void;
  theme?: ButtonTheme;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  buttonOutLine?: boolean;
  bounceEffect?: boolean;
  contentView?: number;
  buttonView?: boolean;
  iconWithText?: boolean;
  iconChild?: React.ReactNode;
}

interface MainBottomButtonViewProps {
  customHeight?: number | null;
  leftButtons?: ButtonProps[];
  rightButtons?: ButtonProps[];
  customBottomContentMain?: string;
  testId?: string;
  theme?: ButtonTheme;
}

const MainBottomMultipleButtonView: React.FC<MainBottomButtonViewProps> = ({
  customHeight = null,
  leftButtons = [],
  rightButtons = [],
  customBottomContentMain = "",
  testId,
  theme = "green"
}) => {
  const { height } = useWindowDimensions();
  const heightView = customHeight || height * 0.1;

  // Calculate width percentage based on Semantic UI grid system (out of 16)
  const getColumnWidth = (contentView: number = 4) => {
    return `${(contentView / 16) * 100}%`;
  };

  return (
    <div
      style={{ height: heightView }}
      className={`tw-flex tw-items-center tw-px-6 tw-py-4 ${customBottomContentMain}`}
    >
      <div className="tw-w-full tw-flex tw-flex-col lg:tw-flex-row tw-gap-4">
        {/* Left Buttons Section */}
        <div className="tw-w-full lg:tw-w-1/2 tw-flex tw-flex-wrap tw-gap-2">
          {leftButtons.map((btn, index) => {
            const showButton = btn?.buttonView ?? true;
            const columnWidth = getColumnWidth(btn?.contentView);

            if (showButton) {
              return (
                <div
                  key={index}
                  style={{ width: `calc(${columnWidth})` }}
                  className="tw-min-w-full lg:tw-min-w-0"
                >
                  <CustomButton
                    theme={btn.theme ?? theme}
                    title={btn.title}
                    onClick={btn.onClick}
                    buttonOutLine={btn.buttonOutLine}
                    className={btn.bounceEffect ? "bounce-effect" : ""}
                    iconWithText={btn.iconWithText}
                    iconChild={btn.iconChild}
                    disabled={btn.disabled}
                    testId={testId ? `${testId}-left-button-${index}` : undefined}
                  />
                </div>
              );
            }
            return null;
          })}
        </div>

        {/* Right Buttons Section */}
        <div className="tw-w-full lg:tw-w-1/2 tw-flex tw-flex-wrap tw-gap-2 lg:tw-justify-end">
          {rightButtons.map((btn, index) => {
            const columnWidth = getColumnWidth(btn?.contentView);
            const btnTestId = btn?.title
              ? btn.title.toLowerCase().replace(/\s+/g, "-")
              : `button-${index}`;

            if (btn?.buttonView) {
              return (
                <div
                  key={index}
                  style={{ width: `calc(${columnWidth})` }}
                  className="tw-min-w-full lg:tw-min-w-0"
                >
                  <CustomButton
                    theme={btn.theme ?? theme}
                    title={btn.title}
                    onClick={btn.onClick}
                    type={btn.type || "button"}
                    disabled={btn.disabled}
                    buttonOutLine={btn.buttonOutLine}
                    className={btn.bounceEffect ? "bounce-effect" : ""}
                    testId={testId ? `${testId}-right-button-${btnTestId}` : undefined}
                  />
                </div>
              );
            }
            return null;
          })}
        </div>
      </div>
    </div>
  );
};

export default MainBottomMultipleButtonView;
